import React, { useContext } from 'react';
import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { AppContext } from '../context';
import { getOrganization } from 'views/App/Portal/LexID/Organizations/_data_sources/useOrganization';
import { Box, CircularProgress } from '@mui/material';
import { Organization } from 'views/App/Portal/LexID/Organizations/_types/organization';
import AuthUtil from 'utils/AuthUtil';
import { useSnackbar } from 'notistack';
import { translate as t } from 'hooks/useTranslations';

export default function SwitchOrganization() {
  const { currentProfile, updatePermissions, setPollForPermissionChanges, hasPermission } = useContext(AppContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  let [searchParams, setSearchParams] = useSearchParams();
  let newId: string = id || '';
  if (newId.length === 0 && currentProfile?.user?.orgId) {
    newId = currentProfile.user?.orgId;
  }
  if (!id || id === '') {
    if (AuthUtil.shouldAllowStorageOperations()) {
      localStorage.setItem('phx-currentOrganizationId', newId?.toString());
      localStorage.setItem('phx-currentOrganizationName', '');
    }
    return <Navigate to={searchParams.get('redir') || '/admin/lexid/organizations'} />;
  } else {
    if (!hasPermission('getOrg', newId)) {
      enqueueSnackbar(t('lexid.permissions.noOrgPermissionOnOrg'), { variant: 'error' });
      return <Navigate to='/admin/dashboard' />;
    }

    getOrganization(newId)
      .then((org: Organization) => {
        if (org) {
          if (AuthUtil.shouldAllowStorageOperations()) {
            localStorage.setItem('phx-currentOrganizationId', newId?.toString());
            localStorage.setItem('phx-currentOrganizationName', org?.organization?.name || '');
          }
          updatePermissions(
            org.organization?.id,
            (org?.organization?.authorizations || []).map((x) => x.action)
          );
          setPollForPermissionChanges(true);
          navigate(searchParams.get('redir') || '/admin/dashboard');
        } else {
          navigate('/admin/dashboard');
        }
      })
      .catch((error) => {
        // Fail gracefully if the organization cannot be loaded instead of hanging
        console.error('Error loading organization during switch-org:', error);
        navigate('/admin/dashboard');
      });
  }

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '40vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
